import { render, staticRenderFns } from "./SpBoard.vue?vue&type=template&id=6846c480&scoped=true"
import script from "./SpBoard.vue?vue&type=script&lang=ts"
export * from "./SpBoard.vue?vue&type=script&lang=ts"
import style0 from "./SpBoard.vue?vue&type=style&index=0&id=6846c480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846c480",
  null
  
)

export default component.exports